import React, { useState } from 'react';
import CabecalhoPagina, { MarcaProduto } from '../components/shared/AppTopbar';
import AppSidebar, { MODULO_LABELS } from '../components/shared/AppSidebar';
import { Sheet, SheetContent } from '../components/ui/sheet';

export default function AppLayout({
  children,
  tenantId,
  tenantNome,
  usuario,
  perfil,
  onLogout,
  abaAtiva,
  onNavegar,
  modulos,
  totalNaoLidas,
  subAbaDisparoAtiva,
  onSubAbaDisparo,
  subAbaFinanceiroAtiva,
  onSubAbaFinanceiro,
  subAbaFinanceiraAtiva,
  onSubAbaFinanceira,
  atendenteAtivo,
  atendenteProcessando,
  onToggleAtendente,
}) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const sidebarProps = {
    abaAtiva,
    onNavegar: (id) => { onNavegar(id); setMobileOpen(false); },
    modulos,
    perfil,
    totalNaoLidas,
    subAbaDisparoAtiva,
    onSubAbaDisparo,
    subAbaFinanceiroAtiva,
    onSubAbaFinanceiro,
    subAbaFinanceiraAtiva,
    onSubAbaFinanceira,
    atendenteAtivo,
    atendenteProcessando,
    onToggleAtendente,
    onLogout,
  };

  // O Dashboard e o Atendimento já abrem com cabeçalho próprio; o resto ganha o título da aba
  const titulo = ['dashboard', 'atendimento'].includes(abaAtiva) ? '' : MODULO_LABELS[abaAtiva];

  return (
    <div className="h-screen flex bg-surface overflow-hidden">
      <div className="hidden lg:flex flex-col bg-white border-r border-slate-200">
        <div className="px-5 pt-6 pb-2 shrink-0">
          <MarcaProduto />
        </div>
        <AppSidebar {...sidebarProps} />
      </div>

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="p-0 w-[248px]">
          <div className="px-5 pt-6 pb-2">
            <MarcaProduto />
          </div>
          <AppSidebar {...sidebarProps} />
        </SheetContent>
      </Sheet>

      <div className="flex flex-1 flex-col min-w-0 overflow-hidden">
        <CabecalhoPagina
          tenantId={tenantId}
          tenantNome={tenantNome}
          titulo={titulo}
          usuario={usuario}
          perfil={perfil}
          onLogout={onLogout}
          onMenuClick={() => setMobileOpen(true)}
        />
        <main className="flex-1 overflow-y-auto p-6 lg:p-8">
          {children}
        </main>
      </div>
    </div>
  );
}
